import { Component } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { RealTimeService } from './core/services/websocket';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [IonApp, IonRouterOutlet],
})
export class AppComponent {

  //If the user is already logged in, we can connect to the real-time service immediately to show presence and receive messages. 
  // Otherwise, we will connect after login.  
  constructor(private realtime: RealTimeService) {
  const token = localStorage.getItem('bwari_jwt_token');

  if (token) {
    this.realtime.connect();
  }
}
}
